<template>
    <div class="account">
      <div class="mainBar">
         <ul class="top">
            <li class="balance">
              <img src="../assets/img/money.png">
              <div>
                当前余额:
                <span><i class="wallet"></i> 元</span>
              </div>
            </li>
            <li class="runWater">
              <img src="../assets/img/liushui.png">
              <div>
                总流水:
                <span><i class="flow"></i>元</span>
              </div>
            </li>
          </ul>
      </div>
      <div class="main">
        <div class="conTop">
          <ul>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <span>明细</span>
        </div>
        <!-- 列表 -->
        <el-table highlight-current-row :data="walletChange.slice((
          currentPage-1)*pagesize,currentPage*pagesize)" stripe
          :header-cell-style="{'width':'15.71rem','color':'rgba(79,79,79,1)','text-align':'center','border-bottom':0,'font-weight':'bold'}"  @click="getWalletChange" >
          <el-table-column prop="handletype" label="操作类型" :formatter="formatHandletype" sortable>
          </el-table-column>
          <el-table-column prop="walletchange" label="余额变动(元)" sortable>
          </el-table-column>
          <el-table-column prop="createtime" label="操作时间" sortable>
          </el-table-column>
          <el-table-column prop="changetype" label="变动账户":formatter="formatChangetype" sortable>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 40]" 
          :page-size="pagesize"  
          layout="total, sizes, prev, pager, next, jumper"
          :total="walletChange.length">  
        </el-pagination>
      </div>
    </div>
</template>
<script>
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'

  export default {
    data(){
     return {
        howAdd: false,
        walletChange:[],
        currentPage:1, //初始页
        pagesize:10, //每页的数据
      }
    },
    created(){
      this.getWalletChange();
      this.getWallet();
    },
    methods:{
      //操作类型转换
      formatHandletype:function(row, column){
        if(row.handletype==1){
          return '充值'
        }
        if(row.handletype==2){
          return '提现'
        }
        if(row.handletype==3){
          return '销售支付'
        }
        if(row.handletype==4){
          return '直接授权'
        }
        if(row.handletype==5){
          return '礼物收入'
        }
        if(row.handletype==6){
          return '下级代理销售提成'
        }
        if(row.handletype==7){
          return '代理激活'
        }
      },
      // 变动账户转换
      formatChangetype:function(row, column){
        if(row.changetype==1){
          return '抵用券'
        }
        if(row.changetype==2){
          return '钱包'
        }
      },
      // 初始页currentPage、初始每页数据数pagesize和数据data
      handleSizeChange: function (size) {
        this.pagesize = size;
        console.log(this.pagesize)  //每页下拉显示数据
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage)  //点击第几页
      },
      // 查询用户账户
      getWallet:function(){
        axios.get("/scene/wallet",{
          params:{
           token:getCookie('session'),
          }
        }).then(res => {
          var wallet=res.data.data.wallet;
          $('.wallet').text(wallet);
          var flow=res.data.data.flow;
          $('.flow').text(flow);
          this.data = res.data;
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 获取账户流水
      getWalletChange:function(){
        axios.get("/scene/walletChange",{
          params:{
            token:getCookie('session')
          }
        }).then(res => {
          this.data = res.data;
          this.walletChange = res.data.data;
          console.log(res.data.data)
          
        }).catch((err)=>{
          console.log(err);
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .account .conTop{
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 0.01rem solid #ccc;
  }
  .account .conTop>ul{
    float: left;
    margin: 0.1rem 0.3rem 0 0.3rem;
  }
  .account .conTop>ul>li{
    width:0.12rem;
    height:0.12rem;
    background:rgba(244,57,65,1);
    border-radius:50%;
    margin: 0 0 0.09rem 0;
  }
  .account .conTop>ul>li:nth-of-type(3){
    margin-bottom: 0;
  }
  .account .conTop>span{
    float: left;
    height:0.4rem;
    font-size:0.3rem;
    font-family:STHeitiSC-Light;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.8rem;
    letter-spacing: 0.2rem;
  }
  .account .top{
    line-height: 0.4rem;
    margin-top: 0.5rem; 
    float: left;
    margin-left: 4rem;
  }
  .account .top>li{
    float: left;
  }
  .account .top,.top>li,.top>li>img,.top>li>div{
    float: left;
  }
  .account .top>li>img{
    margin-top: 0.1rem;
    margin-right: 0.07rem;
  }
  .account .top>li>div{
    height:0.26rem;
    font-size:0.26rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.4rem;
  }
  .account .top>li>div>span{
    height:0.4rem;
    font-size:0.48rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.4rem; 
  }
  .account .top>li:nth-of-type(1){
    margin-right: 0.5rem;
  }
  .account .mainBar{
    width:15.71rem;
    height:1.4rem;
    background:rgba(255,255,255,1); 
    margin-bottom: 0.1rem;
  }
  .account .main{
    width:15.71rem;
    /*height:8.41rem;*/
    margin-top: 0.12rem;
    background:rgba(255,255,255,1);
  }
  .account .middle{
    float: left;
    width: 4.23rem;
    height: 1.83rem;
    padding: 0.3rem 0 0 1.02rem;
    border-bottom: 0.02rem solid #AEAFAF;
  }
  .account .middle>li{
    height:0.18rem;
    line-height: 0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(21,21,21,1);
    margin-bottom: 0.32rem;
  }
  .account .middle>li>span{
    line-height: 0.18rem;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(76,76,76,1);
    letter-spacing: 0.1rem;
  }
  .account .middle>li>i{
    display: inline-block;
    font-weight:300;
    color:rgba(21,21,21,1);
    line-height: 0.18rem;
    height:0.18rem;
    font-size:0.18rem;
    letter-spacing: 0.02rem;
  }
</style>
<style>
  .cell{
    text-align: center;
  }
  .account #check{
    width:1.68rem;
    height:0.45rem;
    background:rgba(244,57,65,1);
    border-radius:0.08rem;
    border: 0; 
    color: #fff;
    margin: 0.1rem 0 0 1.29rem;
    letter-spacing: 0.1rem;
    font-size: 0.18rem;
  }
  .account #check span{
    margin-left: 0.2rem;
  }  
</style>





<!-- <template>
  <div class="account">
    <ul class="top">
      <li class="balance">
        <img src="../assets/img/money.png">
        <div>
          当前余额:
          <span>￥899</span>
        </div>
      </li>
      <li class="runWater">
        <img src="../assets/img/liushui.png">
        <div>
          总流水:
          <span>￥899</span>
        </div>
      </li>
    </ul>
    <div class="contain">
      <div class="conTop">
        <ul>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <span>明细</span>
        <time>2019年06月23日</time>
      </div>
      <ul class="conMain">
        <li>
          <img src="../assets/img/anniu.png">
          <div>
            <i>销售支付</i>:<img src="../assets/img/jia.png">
            <span>899</span>元
          </div>
        </li>
        <li>
          <img src="../assets/img/anniu.png">
          <div>
            <i>直接授权</i>:<img src="../assets/img/jian.png">
            <span>899</span>元
          </div>
        </li>
        <li>
          <img src="../assets/img/anniu.png">
          <div>
            <i>提现</i>:<img src="../assets/img/jian.png">
            <span>899</span>元
          </div>
        </li>
        <li>
          <img src="../assets/img/anniu.png">
          <div>
            <i>充值</i>:<img src="../assets/img/jia.png">
            <span>899</span>元
          </div>
        </li>
      </ul>

    </div>
  </div>  
</template> -->
<!--<style scoped lang="scss">
  .account{
    width:15.71rem;
    height:9.49rem;
    background:rgba(255,255,255,1);
    float: left;
  }
  .top{
    line-height: 0.4rem;
    width: 6.48rem;
    margin-left:4.69rem;
    margin-top: 1.22rem; 
    float: left;
  }
  .top,.top>li,.top>li>img,.top>li>div{
    float: left;
  }
  .top>li>img{
    margin-top: 0.1rem;
    margin-right: 0.07rem;
  }
  .top>li>div{
    height:0.26rem;
    font-size:0.26rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.4rem;
  }
  .top>li>div>span{
    height:0.4rem;
    font-size:0.48rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.4rem; 
  }
  .top>li:nth-of-type(1){
    margin-right: 0.5rem;
  }
  .contain{
    width: 6.48rem;
    height: 5.68rem;
    background:url('../assets/img/bg3.png') no-repeat;
    background-size: 6.48rem 5.68rem;
    margin: 0.54rem 0 0 4.62rem;
    float: left;
  }
  .contain>.conTop{
    height: 0.76rem;
  }
  .contain>.conTop>ul{
    float: left;
  }
  .contain>.conTop>ul>li{
    width:0.12rem;
    height:0.12rem;
    background:rgba(244,57,65,1);
    border-radius:50%;
    margin: 0 0 0.09rem 0.26rem;
  }
  .contain>.conTop>ul>li:nth-of-type(1){
    margin-top: 0.22rem;
  }
  .contain>.conTop>ul>li:nth-of-type(3){
    margin-bottom: 0;
  }
  .contain>.conTop>span{
    float: left;
    height:0.26rem;
    font-size:0.26rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
    line-height:0.26rem;
    margin: 0.36rem 0 0 0.24rem;
  }
  .contain>.conTop>time{
    float: right;
    height:0.16rem;
    font-size:0.16rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(114,114,114,1);
    line-height:0.16rem;
    margin: 0.41rem 0.39rem 0 0;
  }
  .contain>.conMain,.contain>.conMain>li,.contain>.conMain>li>img,.contain>.conMain>li>div{
    float: left;
  }
  .contain>.conMain>li{
    margin-left: 1.64rem;
    height: 0.29rem;
    margin-bottom: 0.55rem;
  }
  .contain>.conMain>li:nth-of-type(1){
    margin-top: 0.57rem;
  }
  .contain>.conMain>li>img{
    margin-top: 0.05rem;
    margin-right: 0.08rem;
  }
  .contain>.conMain>li>div{
    height:0.24rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  .contain>.conMain>li>div>i{
    display: inline-block;
    width: 1.02rem;
    text-align: right;
  }
  .contain>.conMain>li:nth-of-type(3)>div>i,.contain>.conMain>li:nth-of-type(4)>div>i{
    text-align-last:justify;
    text-align:justify;
    text-justify:distribute-all-lines; /*这行必加，兼容ie浏览器*/
  }
  .contain>.conMain>li>div>img{
    margin: 0 0.16rem 0 0.16rem;
  }
  .contain>.conMain>li>div>span{
    height:0.29rem;
    font-size:0.36rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.29rem;
    padding: 0 0.3rem 0 0.16rem;
    border-bottom: 0.01rem solid #DCDCDC;
  }
</style>-->


// WEBPACK FOOTER //
// src/views/account.vue